var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-navitem-nested.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<li class=\"o-secondary-navigation__li o-secondary-navigation__li--accordion o-accordion__tabset js-accordion-tabset is-collapsed\" role=\"menuitem\">\n    <meta itemprop=\"url\" content=\"";
output += runtime.suppressValue((lineno = 3, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "crumb")),"slug"),runtime.contextOrFrameLookup(context, frame, "None"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core"),"absoluteURL": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\" />\n\n    <a href=\"";
output += runtime.suppressValue((lineno = 5, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedAnchorClass"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentlyActive"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue("js-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
output += "\" role=\"menuitem\" ";
output += runtime.suppressValue((lineno = 5, colno = 165, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 5, colno = 171, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"gaLabel")])), env.opts.autoescape);
output += " data-qa-category-navitem=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"slug"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
output += "</a>\n\n    <a href=\"#o-accordion__panel--1\" id=\"o-accordion__tab--1\" class=\"o-accordion__tab js-accordion-tab\" aria-selected=\"true\" aria-controls=\"o-accordion__panel--1\" aria-expanded=\"true\" role=\"tab\" data-accordion-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName"), env.opts.autoescape);
output += "\">\n        <span class=\"o-accordion__control\" title=\"collapse\"></span>\n    </a>\n\n    <div id=\"o-accordion__panel--1\" class=\"o-accordion__panel js-accordion-panel\" aria-labelledby=\"o-accordion__tab--1\" aria-hidden=\"false\" role=\"tabpanel\">\n\n        <ul class=\"o-secondary-navigation__ul o-secondary-navigation__ul--nested\">\n\n            ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"childSlugs");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("navItem", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                ";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),t_4);
frame.set("tertiaryNavItem", t_5, true);
if(frame.topLevel) {
context.setVariable("tertiaryNavItem", t_5);
}
if(frame.topLevel) {
context.addExport("tertiaryNavItem", t_5);
}
output += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")) {
output += "\n                    ";
var t_6;
t_6 = (runtime.contextOrFrameLookup(context, frame, "class") != "" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"itemId") == runtime.contextOrFrameLookup(context, frame, "selectedId")?"o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a" + "" + "--current":"");
frame.set("tertiaryCurrentlyActive", t_6, true);
if(frame.topLevel) {
context.setVariable("tertiaryCurrentlyActive", t_6);
}
if(frame.topLevel) {
context.addExport("tertiaryCurrentlyActive", t_6);
}
output += "\n                    ";
var t_7;
t_7 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"targetUrl")?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"targetUrl"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"slug"));
frame.set("tertiaryNavigationUrl", t_7, true);
if(frame.topLevel) {
context.setVariable("tertiaryNavigationUrl", t_7);
}
if(frame.topLevel) {
context.addExport("tertiaryNavigationUrl", t_7);
}
output += "\n\n                    <li class=\"o-secondary-navigation__li o-secondary-navigation__li--nested\" role=\"menuitem\">\n                        <a href=\"";
output += runtime.suppressValue((lineno = 23, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "categoryUrl"), "categoryUrl", context, [runtime.contextOrFrameLookup(context, frame, "tertiaryNavigationUrl"),runtime.makeKeywordArgs({"core": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue("o-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nestedAnchorClass"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tertiaryCurrentlyActive"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue("js-" + "" + runtime.contextOrFrameLookup(context, frame, "class") + "" + "__a", env.opts.autoescape);
output += "\" role=\"menuitem\" data-qa-category-navitem=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "tertiaryNavigationUrl"), env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((lineno = 23, colno = 251, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 23, colno = 257, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"browse by",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"gaLabel")])), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tertiaryNavItem")),"displayName"), env.opts.autoescape);
output += "</a>\n                    </li>\n                ";
;
}
output += "\n\n            ";
;
}
}
frame = frame.pop();
output += "\n\n        </ul>\n\n    </div>\n\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-navitem-nested.j2"] , dependencies)